import { createTheme } from '@mui/material/styles';
import { colors } from 'Constants/Colors';

export const MexlogTheme = createTheme({
  palette: {
    // Brand green as the MUI primary so components with `color="primary"`
    // (Buttons, Checkbox, TextField focus/hover, etc.) pick it up without
    // per-component `sx` overrides. `light` is the harmonic hover tone used
    // by the OutlinedInput override below.
    primary: {
      main: colors.GREEN,
      light: colors.GREEN_LEAF,
      dark: colors.GREEN,
    },
    MexlogGreen: {
      main: colors.GREEN,
    },
  },
  typography: {
    // La fuente se define una sola vez en GlobalStyle (--app-font).
    fontFamily: 'var(--app-font)',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: 'var(--app-font)',
        },
      },
    },
    // Default MUI hover state on outlined inputs uses `text.primary` (black),
    // which clashes with the brand palette. Switch the hover border to the
    // primary tint so every TextField / Select / Autocomplete picks it up
    // without per-component overrides.
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:hover:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.light,
          },
        }),
      },
    },
  },
});

export default MexlogTheme;
